import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DimmerService {
  private activeModalId = null;
  private activeModalIdOb = new BehaviorSubject<string | null>(null);

  dimmerList = {
    walletDimmer: {
      key: 'walletDimmer',
      open: () => {
        this._UiHelper.shopDropDownIsOpen = true;
      },
      closed: () => {
        this._UiHelper.shopDropDownIsOpen = false;
      },
    },
    loginDimmer: {
      key: 'loginDimmer',
      open: () => {
        this._UiHelper.loginDropDownIsOpen = true;
      },
      closed: () => {
        this._UiHelper.loginDropDownIsOpen = false;
      },
    },
    settingNavbarDimmer: {
      key: 'settingNavbarDimmer',
      open: () => {
        this._UiHelper.settingsDropDownIsOpen = true;
      },
      closed: () => {
        this._UiHelper.settingsDropDownIsOpen = false;
      },
    },
    userNavbarDimmer: {
      key: 'userNavbarDimmer',
      open: () => {
        this._UiHelper.userDropDownIsOpen = true;
      },
      closed: () => {
        this._UiHelper.userDropDownIsOpen = false;
      },
    },
    accountMenuDimmer: {
      key: 'accountMenuDimmer',
      open: () => {
        this._UiHelper.tabsMenuIsOpen = true;
        this._UiHelper.userDropDownIsOpen = false;
        this._Router.navigate([
          {
            outlets: {
              account: ['base'],
            },
          },
        ]);
      },
      closed: () => {
        this._UiHelper.tabsMenuIsOpen = false;
        this._Router.navigate([
          {
            outlets: {
              account: null,
            },
          },
        ]);
      },
    },
    forgetPasswordDimmer: {
      key: 'forgetPasswordDimmer',
      open: () => {
        this._UiHelper.forgotPass = !this._UiHelper.forgotPass;
        this._UiHelper.loginDropDownIsOpen = false;
      },
      closed: () => {
        this._UiHelper.forgotPass = !this._UiHelper.forgotPass;
      },
    },
    langDimmer: {
      key: 'langDimmer',
      open: () => {
        this._UiHelper.langDropdownIsOpen = true;
      },
      closed: () => {
        this._UiHelper.langDropdownIsOpen = false;
        this._UiHelper.settingsDropDownIsOpen = false;
      },
    },
    leftMenuDimmer: {
      key: 'leftMenuDimmer',
      open: () => {
        this._UiHelper.leftMenuState = true;
        document.getElementById('leftSidenav').style.width = '75%';
        this._UiHelper.p1001SetBottomDialogState('close');
      },
      closed: () => {
        this._UiHelper.leftMenuState = false;
        document.getElementById('leftSidenav').style.width = '0';
      },
    },
    rightMenuDimmer: {
      key: 'rightMenuDimmer',
      open: () => {
        this._UiHelper.rightMenuState = true;
        document.getElementById('rightSidenav').style.width = '75%';
        this._UiHelper.p1001SetBottomDialogState('close');
      },
      closed: () => {
        this._UiHelper.rightMenuState = false;
        document.getElementById('rightSidenav').style.width = '0';
      },
    },
    oddTypeDimmer: {
      key: 'oddTypeDimmer',
      open: () => {
        this._UiHelper.settingsModalOpen = true;
        document.getElementById('mainContainerRightSide').style.position = 'static';
      },
      closed: () => {
        this._UiHelper.settingsModalOpen = false;
        document.getElementById('mainContainerRightSide').style.position = 'sticky';
      },
    },
    forgotPassDimmer: {
      key: 'forgotPassDimmer',
      open: () => {
        this._UiHelper.forgotPass = true;
      },
      closed: () => {
        console.log('forgotPassDimmer closed');
        this._UiHelper.forgotPass = false;
      },
    },
  };
  constructor(private _UiHelper: UiHelper, public _Router: Router) {}

  setActiveModalId(id: string) {
    if (this.dimmerList?.[id]) {
      this.dimmerList[id].open();
      this.activeModalId = id;
      this.activeModalIdOb.next(id);
      const bodyElement = document.body;
      bodyElement.classList.add('no-scroll');
    }
  }

  clearActiveModalId() {
    if (this.activeModalId) {
      console.log('close dimmer request:', this.activeModalId);
      this.dimmerList[this.activeModalId].closed();
      this.activeModalId = null;
      this.activeModalIdOb.next(null);
      const bodyElement = document.body;
      bodyElement.classList.remove('no-scroll');
    }
  }

  getActiveModalId(): Observable<string | null> {
    return this.activeModalIdOb.asObservable();
  }
}
